import EditNewslettersForm from "./EditNewslettersForm";

export default EditNewslettersForm;
